import { useTranslation } from 'react-i18next';

// Custom hook for formatting currency based on the current language
export const useFormatCurrency = () => {
  const { t, i18n } = useTranslation();

  const formatCurrency = (amount) => {
    const currencySymbol = t('general.currency');

    // Format number based on locale
    const formattedAmount = new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

    // Return formatted currency with symbol based on language
    if (i18n.language === 'tr') {
      // Turkish format: 149,99 ₺
      return `${formattedAmount} ${currencySymbol}`;
    } else {
      // English format: $149.99
      return `${currencySymbol}${formattedAmount}`;
    }
  };

  return formatCurrency;
};

// Simple currency formatter without translation (for static contexts)
export const formatCurrency = (amount, locale = 'en-US', currency = 'USD') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};